import React, { useState, useEffect, useRef } from 'react';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import Config from '../../../Config';

const CheckboxCollapseLabel = (props) => {

  const bottomText = props.bottomText || '';
  const textButton = props.expandButtonText || 'עוד';
  const closeTextButton = props.closeTextButton || 'קרא פחות';
  const [showExtendedText, setShowExtendedText] = useState(false);
  const [buttonText, setButtonText] = useState('');
  const [originalButtonText, setOriginalButtonText] = useState('');

  const combinedText = props.defaultText + props.extendedText + bottomText;

  useExtendedEffect(() => {
    setButtonText(textButton);
    setOriginalButtonText(textButton);
  }, []);

  const handleToggleExtended = (e) => {
    e.preventDefault();
    setShowExtendedText(prevValue => !prevValue);
    setButtonText(prevValue => (prevValue === closeTextButton ? originalButtonText : closeTextButton));

    if (typeof sendButtonStatus === 'function') {
      sendButtonStatus(buttonText === originalButtonText);
    }
  };
  const ButtonText = () => {
    return <>{buttonText && (
      <span
        onClick={handleToggleExtended}
        className={buttonText ? 'party-button party-button-hover' : 'party-button'}
      >
        {buttonText}
      </span>
    )}
    </>
  }
  return (
    <div className={`checkbox-collapse-label-container   ${buttonText === originalButtonText ? 'closeText' : 'openText'}`}>
      <div className={`custom-scrollbar-content ${showExtendedText ? 'show-scroll' : ''}  ${buttonText === originalButtonText ? 'closeText' : 'openText'}`}>
        <div className="party-content">

          {!showExtendedText && <><span dangerouslySetInnerHTML={{ __html: props.defaultText }} /><ButtonText /></>}
          {showExtendedText && props.extendedText && (
            <>
              <div className="extended-text">
                <span dangerouslySetInnerHTML={{ __html: props.extendedText }} />
                <ButtonText />
              </div>
            </>
          )}

          {props.bottomText && <><span className="bottom-text" dangerouslySetInnerHTML={{ __html: props.bottomText }} /></>}
        </div>
      </div>
    </div>
  );
};

export default CheckboxCollapseLabel;
